module.exports = __webpack_public_path__ + "img/img-11.34ad8c1e.png";